<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-compare"
          inline
          class="px-5 py-4 ml-0"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Visualizar Gráficos: {{ nome }}
            </div>
          </template>

          <v-tabs
            class="my-10"
            v-model="tab"
            background-color="grey lighten-3"
            color="white"
            grow
            slider-size="65"
          >
            <v-tabs-slider class="mt-1" color="primary" />

            <v-tab :ripple="false">
              KPIs
            </v-tab>
            <v-tab :ripple="false">
              Mensal
            </v-tab>
            <v-tab :ripple="false">
              Trimestral
            </v-tab>
            <v-tab :ripple="false">
              Semestral
            </v-tab>
            <v-tab :ripple="false">
              Nonamestral
            </v-tab>
            <v-tab :ripple="false">
              Anual ({{ ano }})
            </v-tab>
          </v-tabs>

          <v-row justify="center" class="mx-auto" v-if="tab == 0">
            <v-col cols="12">  
              <tabela-kpis 
                :rows="resultado.kpis"
                :loading="loading" 
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mx-auto" v-if="tab == 1">
            <v-col cols="12">  
              <grafico
                type="mensal"
                title="[KPI 1] Aderência Mensal Incremento Físico vs Contábil" 
                :series="resultado.mensal"
                :year="ano" 
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mx-auto" v-if="tab == 2">
            <v-col cols="12">  
              <grafico
                type="trimestral"
                title="[KPI 2] Aderência Trimestral Físico vs Contábil" 
                :series="resultado.trimestral"
                :year="ano" 
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mx-auto" v-if="tab == 3">
            <v-col cols="12">  
              <grafico
                type="semestral"
                title="[KPI 3] Aderência Semestral Físico vs Contábil" 
                :series="resultado.semestral"
                :year="ano" 
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mx-auto" v-if="tab == 4">
            <v-col cols="12">  
              <grafico
                type="nonamestral"
                title="[KPI 4] Aderência Nonamestral Físico vs Contábil" 
                :series="resultado.nonamestral"
                :year="ano" 
              />
            </v-col>
          </v-row>
          <v-row justify="center" class="mx-auto" v-if="tab == 5">
            <v-col cols="12">  
              <grafico
                type="anual"
                title="[KPI 5] Aderência Anual Físico vs Contábil" 
                :series="resultado.anual"
                :year="ano" 
              />
            </v-col>
          </v-row>    
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import KpisAderenciasBdgdService from "@/services/KpisAderenciasBdgdService";

export default {
  name: "KpisAderenciasBdgdVisualizar",
  components: {
    TabelaKpis: () => import("@/components/kpisAderenciasBdgd/TabelaKpis.vue"),
    Grafico: () => import("@/components/kpisAderenciasBdgd/Grafico.vue")  
  },
  data() {
    return {
      tab: 0,
      nome: "",
      ano: (new Date).getFullYear(),
      resultado: {
        kpis: [],
        mensal: [],
        trimestral: [],
        semestral: [],
        nonamestral: [],
        anual: [],    
      },
      loading: true,
    };
  },
  mounted() {
    this.getDados();
  },
  methods: {
    getDados() {
      const id = this.$route.params.id;
      KpisAderenciasBdgdService.getDadosGrafico(id)
        .then((response) => {
          this.nome = response.data.nome;
          this.ano = response.data.resultado.ano;
          this.resultado = response.data.resultado;
        })
        .catch((err) => {
          console.log("Erro: ", err);
          this.$toast.error("Erro ao recuperar dados do gráfico.", "", {
            position: "topRight",
          });
          this.$router.push({
            name: 'KPIs Aderências BDGD Histórico'
          });
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>

<style lang="sass">
.v-tabs-bar
  height: 56px !important
  padding: 0 0px

.v-tabs-slider-wrapper
  overflow: visible

.v-tabs-slider
  border-radius: 4px

.v-tabs-slider-wrapper
  contain: initial
  z-index: 0

.v-data-table__wrapper 
  overflow-x: visible 
  overflow-y: visible 
</style>